import { useMemo } from 'react'
import { useDmsAndGdms } from 'use-towns-client'

export const useRecentUsers = (userId?: string, limit = 10) => {
    const { dmsAndGdms } = useDmsAndGdms()
    return useMemo(() => {
        return dmsAndGdms.reduce((acc, channel) => {
            if (acc.length >= limit) {
                return acc
            }
            channel.userIds.forEach((id) => {
                if (id !== userId && !acc.includes(id)) {
                    acc.push(id)
                }
            })
            return acc
        }, [] as string[])
    }, [dmsAndGdms, limit, userId])
}
